import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Text, mergeStyleSets, Stack } from '@fluentui/react';
const contentStyles = mergeStyleSets({
    italicFont: {
        fontStyle: 'italic'
    },
    title: {
        marginTop: 4
    },
    subTitle: {
        marginTop: 8
    },
    leftSpace: {
        paddingLeft: 6
    }
});
export const ShowingResultsFor = ({ showingResultsForText, previousSearchText }, context)=>{
    const { title, leftSpace, italicFont } = contentStyles;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                children: [
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: /*#__PURE__*/ _jsx(Text, {
                            variant: "medium",
                            children: `${context.loc('Showing_Results_For_NoResults_Prefix', 'No results found for')} `
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        className: leftSpace,
                        children: /*#__PURE__*/ _jsx(Text, {
                            className: "ms-fontSize-14 ms-fontWeight-semibold",
                            children: `‘${previousSearchText}’`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                className: title,
                children: [
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        children: /*#__PURE__*/ _jsx(Text, {
                            className: "ms-fontSize-20",
                            children: `${context.loc('Showing_Results_For_Prefix', 'Showing results for')} `
                        })
                    }),
                    /*#__PURE__*/ _jsx(Stack.Item, {
                        className: leftSpace,
                        children: /*#__PURE__*/ _jsx(Text, {
                            as: 'h1',
                            variant: "xLarge",
                            className: italicFont,
                            children: `‘${showingResultsForText}’`
                        })
                    })
                ]
            })
        ]
    });
};
ShowingResultsFor.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
